<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6">
                <form class="mb-3" v-on:submit.prevent="onSubmit()">
                    <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                    <div class="form-group">
                        <label
                            :for="'name' + template_font.id"
                            :id="'name-label' + template_font.id"
                            class="mandatory-label"
                        >
                            {{ $root.text('Name', null, true) }} *
                        </label>
                        <input
                            v-model="template_font.name"
                            type="text"
                            :id="'name' + template_font.id"
                            class="form-control mandatory-field"
                            :readonly="updating"
                            v-on:keyup="$root.unHighlightErrors('name', template_font.id)"
                            v-on:change="$root.unHighlightErrors('name', template_font.id)"
                        >
                    </div>

                    <span v-if="!updating">
                        <button
                            :key="'save-button'"
                            type="submit"
                            class="btn btn-primary mr-2"
                            :disabled="updating"
                        >
                            <i class="far fa-save mr-1"></i> {{ $root.text('Save', null, true) }}
                        </button>
                    </span>
                    <span v-else>
                        <button :key="'saving-button'" type="button" class="btn btn-primary mr-2">
                            <i class="fal fa-spinner-third fa-spin mr-1"></i>
                            <span style="opacity: 0.5">{{ $root.text('Save', null, true) }}</span>
                        </button>
                    </span>
                    <button
                        :key="'delete-button'"
                        type="button"
                        class="btn btn-secondary"
                        :disabled="updating"
                        @click.prevent="deleteTemplateFont()"
                    >
                        <i class="far fa-trash-alt mr-1"></i> {{ $root.text('Delete', null, true) }}
                    </button>
                </form>
            </div>
            <div class="col-lg-9 col-md-8 col-sm-6">
                <label>{{ $root.text('Files', null, true) }}</label>

                <div v-if="files_loading"><loading :align="'left'"></loading></div>

                <div
                    v-if="files_errors"
                    v-html="files_errors"
                    class="alert alert-danger"
                    role="alert"
                ></div>

                <div v-if="(!files_errors && !files_loading)">
                    <div
                        v-if="!hasFiles()"
                        class="alert alert-warning"
                        role="alert"
                    >
                        {{ $root.text('There are no files in this font', null, true) }}
                    </div>
                    <template-font-files
                        v-if="hasFiles()"
                        :files="template_font.files"
                    ></template-font-files>

                    <!--<div class="text-right">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-toggle="modal"
                            data-target="#template-font-file-add-form-modal"
                            @click.prevent="resetTemplateFontFileAddForm()"
                        >
                            <i class="far fa-cloud-upload mr-1"></i> {{ $root.text('Upload file', null, true) }}
                        </button>
                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data'],
        data () {
            return {
                errors: false,
                updating: false,
                template_font: {},
                files_loading: false,
                files_errors: false
            }
        },
        mounted () {
            if (this.data) {
                this.template_font = this.data;
            }
        },
        watch: {
            data: function (val) {
                this.template_font = val;
            }
        },
        methods: {
            onSubmit: function () {
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');
                this.errors = false;
                this.updating = true;

                /**
                 * Send update template font request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/template-font/'
                    + this.template_font.id;
                var vm = this;

                axios({
                    method: 'put',
                    url: url,
                    data: vm.template_font,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    // Show confirmation message.
                    vm.$parent.$parent.message = {
                        type: 'success',
                        title: vm.$root.text(
                            'Update {template} font',
                            {
                                template: this.$root.text(
                                    this.$root.contents.template_title,
                                    null,
                                    false,
                                    'template_title'
                                )
                            },
                            true
                        ),
                        text: response.data.message
                    };
                    $('#message-modal').modal('show');

                    // Close after 2 seconds automatically.
                    setTimeout(function() {
                        $('#message-modal').modal('hide');
                    }, 2000);
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                        if (typeof error.response.data.error === 'string') {
                            vm.errors = error.response.data.error;
                        } else if (typeof error.response.data.error === 'object') {
                            vm.errors = '';
                            for (const [key, value] of Object.entries(error.response.data.error)) {
                                vm.errors += value.join('<br>') + '<br>';
                                $('#' + key + '-label' + vm.template_font.id).addClass('text-danger');
                                $('#' + key + vm.template_font.id).addClass('field-error');
                            }
                        }
                    }
                })
                .finally(() => {
                    vm.updating = false;
                });
            },
            getTemplateFontFiles: function () {
                this.files_errors = false;
                this.files_loading = true;

                /**
                 * Send get template fonts request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id
                    + '/template-fonts/ft::' + this.template_font.id;
                var vm = this;

                axios({
                    url: url/*,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }*/
                })
                .then(response => {
                    vm.template_font.files = response.data.fonts ? response.data.fonts[0].files : [];
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    vm.files_errors = error.response.data.error
                        || vm.$root.text('Something went wrong, please try again', null, true);
                })
                .finally(() => {
                    vm.files_loading = false;
                });
            },
            /*resetTemplateFontFileAddForm: function () {
                const component = this.$root.findComponent(this.$parent, 'template-font-file-add-form');
                if (component) {
                    component.resetForm(this.template_font, this);
                }
            },*/
            hasFiles: function () {
                if (!this.template_font.files) {
                    return false;
                }

                return (this.template_font.files.length > 0);
            },
            deleteTemplateFont: function (confirmed = false) {
                if (confirmed) {
                    this.errors = false;
                    this.$parent.loading = true;

                    /**
                     * Send delete template font request to API.
                     */
                    const url = this.$root.app.api_url + '/' + this.$root.app.client_id
                        + '/template-font/' + this.template_font.id;
                    var vm = this;

                    axios({
                        method: 'delete',
                        url: url,
                        headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                    })
                    .then(response => {
                        vm.$parent.getFonts();

                        // Update font files.
                        vm.$root.updateTemplateFonts();
                    })
                    .catch(function (error) {
                        if (error.response.status == 401) {
                            // Missing/lost API token - logout user.
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            vm.errors = error.response.data.error;
                        }
                    });

                    return null;
                }

                if (this.updating) {
                    return null;
                }

                this.$parent.$parent.confirm_delete = {
                    title: this.$root.text(
                        'Delete {template} font',
                        {
                            template: this.$root.text(
                                this.$root.contents.template_title,
                                null,
                                false,
                                'template_title'
                            )
                        },
                        true
                    ),
                    text: this.$root.text(
                        'Are you sure you want to delete: {name}?',
                        { name: this.template_font.name },
                        true
                    ),
                    component: this,
                    action: 'delete-font'
                };
                $('#confirm-delete-modal').modal('show');
            },
            confirmDelete: function (action) {
                this.deleteTemplateFont(true);
            }
        }
    }
</script>
